module.exports = __webpack_public_path__ + "img/group.0422d847.png";